import Axios from 'axios';

import { getRoot } from './config';
import { createResponseInterceptor, createErrorInterceptor } from './interceptors';

const qs = require('qs');

const XHR = Axios.create({
    headers: { Pragma: 'no-cache' },
    baseURL: getRoot(),
    paramsSerializer: {
        serialize: (params) => qs.stringify(params, { arrayFormat: 'index' }),
    },
});

/**
 * Applies response and error interceptors to XHR. These interceptors
 * will use the callback functions given, according to the result of the
 * request
 *
 * @param {Function} handleError - Called with keys `config` and `response`. Reponse may be undefined of nothing was returned
 * @param {Function} handleSuccess - Called with reponse data as first param
 */
const applyInterceptors = (handleError, handleSuccess) => {
    XHR.interceptors.response.use(
        createResponseInterceptor(handleError, handleSuccess),
        createErrorInterceptor(handleError),
    );
};

export { XHR, applyInterceptors };
